"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingDockScanEventApiErrorCode = void 0;
exports.LoadingDockScanEventApiErrorCode = {
    DUPLICATE_SCAN: 'DUPLICATE_SCAN',
    INVALID_STATE: 'INVALID_STATE',
    MISMATCHED_BOL_PALLET_LABEL_DESTINATIONS: 'MISMATCHED_BOL_PALLET_LABEL_DESTINATIONS',
    SCAN_LOCATION_NOT_IN_JOURNEY: 'SCAN_LOCATION_NOT_IN_JOURNEY',
    UNABLE_TO_LOAD_SHIPMENT_DETAILS_FOR_PALLET: 'UNABLE_TO_LOAD_SHIPMENT_DETAILS_FOR_PALLET',
    UNKNOWN_BOL: 'UNKNOWN_BOL'
};
//# sourceMappingURL=loading-dock-scan-event-api-error-code.js.map